import React from "react";
import styles from "./DealerDeliveryRanges.module.scss";

export const EffectiveDateBand = (props) => {
  return (
    <div className={styles.effectiveDateContainer}>
      <div className={styles.effectiveDateBorder} />
      <span className={styles.effectiveDateContent}>
        {props.text}&nbsp;{props.date}
      </span>
      <div className={styles.effectiveDateBorder} />
    </div>
  );
};
